<template>
  <div class="leave-management">
    <!-- 页面头部 -->
    <div class="page-header">
      <el-page-header @back="goBack" :content="`${technicianName} - 休假管理`"></el-page-header>
    </div>

    <!-- 操作区域 -->
    <div class="operation-area" style="margin: 20px 0;">
      <el-button type="primary" @click="handleAdd" v-auth="'/technician/leave/add'" size="small">
        <i class="el-icon-plus"></i> 添加休假
      </el-button>
    </div>

    <!-- 休假列表 -->
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="leave_type" label="休假类型" width="100"></el-table-column>
        <el-table-column label="休假时间" width="200">
          <template slot-scope="scope">
            <div>
              <div>开始：{{ scope.row.start_time }}</div>
              <div>结束：{{ scope.row.end_time }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="休假时长" width="100">
          <template slot-scope="scope">
            {{ calculateDuration(scope.row.start_time, scope.row.end_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/technician/leave/edit'">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small" style="color: #f56c6c;" v-auth="'/technician/leave/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                     :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                     :total="totalDataNumber">
      </el-pagination>
    </div>

    <!-- 添加休假弹窗 -->
    <Add v-if="openAdd" :open_add="openAdd" :technician="technicianInfo" @closeDialog="closeDialog"></Add>

    <!-- 编辑休假弹窗 -->
    <Edit v-if="openEdit" :open_edit="openEdit" :leave_data="currentLeave" @closeDialog="closeDialog"></Edit>
  </div>
</template>

<script>
import LeaveApi from '@/api/technician/leave.js';
import Add from './Add.vue';
import Edit from './Edit.vue';

export default {
  name: 'LeaveManagement',
  components: {
    Add,
    Edit
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 10,
      totalDataNumber: 0,
      curPage: 1,
      technicianId: 0,
      technicianName: '',
      technicianInfo: {},
      openAdd: false,
      openEdit: false,
      currentLeave: {}
    };
  },
  created() {
    // 从路由参数获取技师信息
    this.technicianId = this.$route.query.technician_id;
    this.technicianName = this.$route.query.technician_name || '未知技师';
    this.technicianInfo = {
      id: this.technicianId,
      name: this.technicianName
    };

    if (this.technicianId) {
      this.getData();
    } else {
      this.$message.error('缺少技师信息');
      this.goBack();
    }
  },
  methods: {
    /**
     * 获取休假列表数据
     */
    getData() {
      let self = this;
      let params = {
        technician_id: self.technicianId,
        page: self.curPage,
        list_rows: self.pageSize
      };
      self.loading = true;
      LeaveApi.getList(params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /**
     * 计算休假时长
     */
    calculateDuration(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffTime = Math.abs(end - start);
      
      // 计算天数（向下取整）
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      // 计算剩余小时数
      const remainingHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      // 计算剩余分钟数
      const remainingMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
      
      if (diffDays > 0) {
        // 有天数的情况
        if (remainingHours > 0) {
          return `${diffDays}天${remainingHours}小时`;
        } else {
          return `${diffDays}天`;
        }
      } else if (remainingHours > 0) {
        // 只有小时数的情况
        if (remainingMinutes > 0) {
          return `${remainingHours}小时${remainingMinutes}分钟`;
        } else {
          return `${remainingHours}小时`;
        }
      } else {
        // 只有分钟数的情况
        return `${remainingMinutes}分钟`;
      }
    },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 添加休假
     */
    handleAdd() {
      this.openAdd = true;
    },
    /**
     * 编辑休假
     */
    handleEdit(row) {
      this.currentLeave = { ...row };
      this.openEdit = true;
    },
    /**
     * 删除休假
     */
    handleDelete(row) {
      this.$confirm('确认删除这条休假记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        LeaveApi.del({ id: row.id }, true)
          .then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.getData();
            }
          })
          .catch(error => {
            // 错误已在request中处理
          });
      }).catch(() => {
        // 用户取消删除
      });
    },
    /**
     * 关闭弹窗
     */
    closeDialog(e) {
      this.openAdd = false;
      this.openEdit = false;
      this.currentLeave = {};

      // 如果操作成功，刷新列表
      if (e && e.type === 'success') {
        this.getData();
      }
    },
    /**
     * 每页条数改变
     */
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /**
     * 当前页改变
     */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.leave-management {
  /*padding: 20px;*/
}

.page-header {
  margin-bottom: 20px;
}

.operation-area {
  margin: 20px 0;
}

.table-wrap {
  /*background: #fff;*/
  /*padding: 20px;*/
  /*border-radius: 4px;*/
  /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
}

.pagination {
  margin-top: 20px;
  /*text-align: center;*/
}
</style>



// WEBPACK FOOTER //
// src/views/technician/leave/index.vue